var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-list-container",attrs:{"id":"data-list-list-view"}},[_c('h1',[_vm._v("This is detail of doctor")])])
}]

export { render, staticRenderFns }